import {usePersonInfo} from '@/data/Content/PersonInfo';
import {useNotifications} from '@/data/Content/Notifications';

export const useSuccessLoginNotify = () => {
    const {mutatePersonInfo} = usePersonInfo();
		const {showSuccessUserLogin} = useNotifications();

    const showSuccessAuthLogin = async () => {
        const data = await mutatePersonInfo();
				showSuccessUserLogin(data?.firstName ?? '');
    };

    return {showSuccessAuthLogin};
};
